import React, { FunctionComponent } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';
import cn from 'classnames';

export type TTableRowProps = TParentComponentProps & {
  heading?: boolean;
  product?: boolean;
  price?: boolean;
  quantity?: boolean;
  total?: boolean;
  action?: boolean;
  checkout?: boolean;
  address?: boolean;
  checkoutAddress?: boolean;
  reversedLink?: boolean;
};

export const TableCol: FunctionComponent<TTableRowProps> = ({
  heading,
  product,
  price,
  quantity,
  total,
  action,
  checkout,
  address,
  checkoutAddress,
  reversedLink,
  className,
  ...otherProps
}) => {
  const componentClassName = cn({
    'cart-table__col--head': !!heading,
    'cart-table__col--product': !!product,
    'cart-table__col--price': !!price,
    'cart-table__col--quantity': !!quantity,
    'cart-table__col--total': !!total,
    'cart-table__col--action': !!action,
    'cart-table__col--checkout-action': !!checkout,
    'cart-table__col--checkout-address': !!checkoutAddress,
    'cart-table__col--reversed-link': !!reversedLink,
    [className]: !!className,
  });

  return <ParentComponent className={componentClassName} {...otherProps} />;
};

TableCol.defaultProps = {
  defaultClassName: 'cart-table__col',
  as: 'td',
};

export default TableCol;
